import { render, staticRenderFns } from "./SiteConfigConfirmModal.vue?vue&type=template&id=64080400&scoped=true&"
import script from "./SiteConfigConfirmModal.vue?vue&type=script&lang=js&"
export * from "./SiteConfigConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64080400",
  null
  
)

export default component.exports